import { CustomDialog } from "../../../../components/customDialog/CustomDialog";

export const DialogConfirmacion = ({
    open,
    title,
    onAccept,
    onCancel,
    acceptText = 'Aceptar',
    cancelText = 'Cancelar',
    children,
    loading
}) => {
    return (
        <CustomDialog
            maxWidth='sm'
            fullWidth
            open={open}
            title={title}
            onCancel={onCancel}
            onAccept={onAccept}
            acceptText={acceptText}
            cancelText={cancelText}
            cancelDisabled={loading}
            acceptLoading={loading}
            onBackdropClick={loading ? () => { } : null} //Si está cargando, no permitir cerrar haciendo click fuera del diálogo
        >
            {children}
        </CustomDialog>
    );
};